import { COMMUNITY_TYPE } from 'src/client/types'
import { useCommunityDetails } from 'src/pages/CommunityDetails/Posts/context/communityDetailsContext'
import usePublicCommunity from '../usePublicCommunity'

const usePublicCommunityReactionClick = () => {
  const { community } = useCommunityDetails()

  const { setCommentToStore, setShouldStoreComment, setIsPublicCommunityModalOpen } =
    usePublicCommunity()

  const shouldCallReactionClick =
    community?.type === COMMUNITY_TYPE.PUBLIC && !community.isOwner && !community?.isOwnerOrFollower

  const handlePublicCommunityReactionClick = (shouldStoreCommentParam = false, comment = '') => {
    if (shouldStoreCommentParam) {
      setShouldStoreComment(true)
      setCommentToStore(comment)
    } else {
      setShouldStoreComment(false)
    }

    setIsPublicCommunityModalOpen(true)
  }

  return {
    shouldCallReactionClick,
    handlePublicCommunityReactionClick
  }
}

export default usePublicCommunityReactionClick
